import { useQuery } from "convex/react"
import { api } from "../../../../convex/_generated/api"

export function useWorkspaceState() {
  return useQuery(api.companies.myWorkspaceState)
}
